import { useState, useEffect, useRef } from "react";
const useShowInterstitial = () => {
    const [showScreen, setShowScreen] = useState(localStorage.getItem("_tz99") !== "_tz99");
    const [showPage, setShowPage] = useState(!showScreen);
    const timer = useRef(null);
    const pagetimer = useRef(null);
    useEffect(() => {
        if (showScreen) {
            timer.current = setInterval(() => {
                setShowScreen(false);
                localStorage.setItem("_tz99", "_tz99");
            }, 8000);
            pagetimer.current = setInterval(() => {
                setShowPage(true);
            }, 3000);
        }
        return () => {
            timer.current && clearInterval(timer.current);
            pagetimer.current && clearInterval(pagetimer.current);
        };
    }, []);
    return {
        showPage,
        showScreen,
    };
};
export default useShowInterstitial;
